export default function AuthFormSkeleton() {
  return (
    <div className="space-y-5 px-4 py-6">
      <div className="mx-auto h-8 w-32 animate-pulse rounded bg-[#F0E0C7]/60" />
      <div className="mx-auto h-4 w-64 animate-pulse rounded bg-[#F0E0C7]/60" />
      {Array.from({ length: 4 }).map((_, index) => (
        <div key={`auth-field-${index}`} className="space-y-2">
          <div className="h-4 w-24 animate-pulse rounded bg-[#F0E0C7]/60" />
          <div className="h-10 w-full animate-pulse rounded-lg bg-[#F0E0C7]/60" />
        </div>
      ))}
      <div className="h-11 w-full animate-pulse rounded-full bg-[#F0E0C7]/60" />
    </div>
  );
}
